import { render, staticRenderFns } from "./OutsourceStatusBadge.vue?vue&type=template&id=42f12fbc"
import script from "./OutsourceStatusBadge.vue?vue&type=script&lang=js"
export * from "./OutsourceStatusBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports